global.allCountryList = global.API_ADMIN_URL+'allCountryList/';
global.countryAETaxName = global.API_ADMIN_URL+'countryAETaxName/';
global.countryManageStatus = global.API_ADMIN_URL+'countryManageStatus/';
